import React from 'react';

import PropTypes from 'prop-types';

import theme from '@adsk/alloy-react-theme';

import getPluginKey from './helpers/getPluginKey';
import { pluginShape } from './helpers/propTypes';

const TypeButtonLabel = ({ plugin, disabled, showIcon }) => {
  const { CustomOptionLabel } = plugin;
  const OptionLabel = CustomOptionLabel || plugin.PluralText;

  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          ...(!disabled && {
            color: theme.colors.charcoal900,
          }),
        },
      ]}
      data-testid={`TypeButtonLabel--${getPluginKey(plugin)}`}
    >
      {showIcon &&
        plugin.renderIcon({
          style: {
            ...(!disabled && {
              color: theme.colors.charcoal700,
            }),
            marginRight: 10,
          },
        })}
      <OptionLabel />
    </div>
  );
};

TypeButtonLabel.defaultProps = {
  showIcon: true,
};

TypeButtonLabel.propTypes = {
  /**
   * The plugin we want to show label for
   */
  plugin: pluginShape.isRequired,
  /**
   * Whether the option is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Whether show icon.
   */
  showIcon: PropTypes.bool,
};

export default TypeButtonLabel;
